// extracted by mini-css-extract-plugin
export default {"contentContainer":"ArchiveModalBox_contentContainer_wVDxg","spinAround":"ArchiveModalBox_spinAround_ZpArm"};